import React, { useState } from 'react'
import ContentLoader from 'react-content-loader'
import CalificacionesPlaceholderMobile from '../../../resultado-calificacion-empresa/components/placeholder/CalificacionesPlaceholderMobile'

// mixins
import { LoaderContainer, PlaceholderData, SectionContainer } from './mixins'

const FichaAvisoEmpresaPlaceholderDesktop = () => {
  const [wrapperWidth, setWrapperWidth] = useState(0)
  const widthWithoutMargin = wrapperWidth - 32
  return (
    <SectionContainer>
      <LoaderContainer ref={node => node && setWrapperWidth(node.offsetWidth)}>
        {/* Company */}
        <PlaceholderData>
          <ContentLoader
            speed={2}
            width={wrapperWidth}
            height={256}
            viewBox="0 0 100% 100%"
            backgroundColor="#f3f3f3"
            foregroundColor="#d4d4d4"
          >
            <rect x="16" y="16" rx="4" ry="4" width={widthWithoutMargin * 0.4} height="16" />
            <rect x="16" y="48" rx="4" ry="4" width={widthWithoutMargin * 0.6} height="16" />
            <rect x="16" y="80" rx="4" ry="4" width={widthWithoutMargin * 0.5} height="16" />
            <rect x="16" y="112" rx="4" ry="4" width={widthWithoutMargin * 0.7} height="16" />
            <rect x="16" y="160" rx="4" ry="4" width={widthWithoutMargin} height="16" />
            <rect x="16" y="192" rx="4" ry="4" width={widthWithoutMargin} height="16" />
            <rect x="16" y="224" rx="4" ry="4" width={widthWithoutMargin * 0.9} height="16" />
          </ContentLoader>
        </PlaceholderData>

        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height={72}
          viewBox="0 0 100% 100%"
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <rect x="0" y="0" rx="8" ry="8" width={wrapperWidth} height="48" />
        </ContentLoader>
      </LoaderContainer>
      <CalificacionesPlaceholderMobile />
    </SectionContainer>
  )
}

export default FichaAvisoEmpresaPlaceholderDesktop
